/** @module Apparel/QueryFilterController */
define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/core/ExtendedPath",
	"csi/heading/RefFilterController",
	"csi/locale",
	"csi/prefs",
	"csi/prefs/BrowseAttributesStore",
	"csi/reflection",
	"csi/xml"
], function(array, declare, ExtendedPath, RefFilterController, locale, prefs, BrowseAttributesStore, reflection, xml) {

	return declare(RefFilterController, {
		/** @property {string} queryFilterType - what type will be queried for */
		queryFilterType: "Style",

		/** @property {string} queryFilterStartType - what type to start searching for attributes from */
		queryFilterStartType: "Style",

		/** @property {Object} queryFilterPaths - contains paths to attributes the query will be filtered by */
		queryFilterPaths: {
			ApparelBOM: [
				{m_path: "__Parent__|Style"},
				{m_path: "__Parent__|Style/Attributes"},
				{m_path: "__Parent__|Style/ProductSourcing"},
				{m_path: "__Parent__|Style/Spec"},
				{m_path: "__Parent__|Style/ProductType"}
			],
			Category1: [
				{m_path: "Child:Defaults"},
				{m_path: "Child:Attributes"},
				{m_path: "Child:ParentSeason"}
			],
			Category2: [
				{m_path: "Child:Category1"},
				{m_path: "Child:Defaults"},
				{m_path: "Child:Attributes"},
				{m_path: "Child:ParentSeason"}
			],
			Collection: [
				{m_path: "Child:Category1"},
				{m_path: "Child:Category2"},
				{m_path: "Child:Defaults"},
				{m_path: "Child:Attributes"},
				{m_path: "Child:ParentSeason"}
			],
			Colorway: [
				{m_path: "Child:ColorSpecification"},
				{m_path: "__Parent__|Style"},
				{m_path: "__Parent__|Style/Attributes"},
				{m_path: "__Parent__|Style/ProductSourcing"},
				{m_path: "__Parent__|Style/Spec"},
				{m_path: "__Parent__|Style/ProductType"}
			],
			ColorMaterial: [
				{m_path: "Child:ColorSpecification"},
				{m_path: "__Parent__|Material"},
				{m_path: "__Parent__|Material/Attributes"},
				{m_path: "__Parent__|Material/ProductSourcing"},
				{m_path: "__Parent__|Material/Spec"},
				{m_path: "__Parent__|Material/ProductType"}
			],
			Material: [
				{m_path: "Child:Attributes"},
				{m_path: "Child:ProductSourcing"},
				{m_path: "Child:Spec"},
				{m_path: "Child:ProductType"},
				{m_path: "Child:Libraries"},
				{m_path: "Child:MaterialOriginalSeason"},
				{m_path: "Child:MaterialOriginalCategory1"},
				{m_path: "Child:ProductSourcing/Child:DefaultQuote"},
				{m_path: "Child:ProductSourcing/Child:DefaultQuote/Child:__Parent__/Child:Supplier"}
			],
			MaterialSupplierItem: [
				{
					m_path: "Child:LatestRevision",
					groupIdFunc: function() {
						return locale.type("SupplierItem") + " - " + locale.type("_CS_Revision");
					}
				},
				{m_path: "Child:LatestRevision/Child:QuoteFactory"},
				{m_path: "__Parent__|ProductSource"},
				{m_path: "__Parent__|ProductSource/Supplier"},
				{
					m_path: "__Parent__|ProductSource/Supplier|Supplier/Agent",
					groupIdFunc: function() {
						return locale.typeId("Supplier", "Agent");
					}
				},
				{m_path: "__Parent__|ProductSource/__Parent__|MaterialSourcing"},
				{m_path: "__Parent__|ProductSource/__Parent__|MaterialSourcing/__Parent__|Material"},
				{m_path: "__Parent__|ProductSource/__Parent__|MaterialSourcing/__Parent__|Material/MaterialOriginalSeason"},
				{m_path: "__Parent__|ProductSource/__Parent__|MaterialSourcing/__Parent__|Material/MaterialOriginalCategory1"},
				{m_path: "Child:LatestRevision/Child:QuoteProductAlternative"},
				{m_path: "Child:LatestRevision/Child:QuoteProductAlternative/Child:PASpec"}
			],
			PartMaterial: [
				{m_path: "Child:Actual"},
				{m_path: "Child:__Parent__"}
			],
			PurchasedOrder: [
				{m_path: "Child:PurchaseTerms"},
				{m_path: "Child:POSupplier"},
				{m_path: "Child:POFactory"},
				{m_path: "Child:POSupplierAttributes"},
				{m_path: "Child:Rollup"},
				{m_path: "Child:__Parent__"}
			],
			ReviewStyle: [
			],
			SizeChartDimension: [
				{m_path: "Child:Actual"},
				{m_path: "Child:__Parent__"}
			],
			SpecificationDataSheetItem: [
				{m_path: "Child:Actual"},
				{m_path: "Child:__Parent__"}
			],
			Style: [
				{m_path: "Child:Attributes"},
				{m_path: "Child:ProductSourcing"},
				{m_path: "Child:Spec"},
				{m_path: "Child:ProductType"},
				{m_path: "Child:Category1"},
				{m_path: "Child:Category2"},
				{m_path: "Child:Collection"},
				{m_path: "Child:ParentSeason"},
				{m_path: "Child:Theme"},
				{
					m_path: "Child:ProductSourcing/Child:ProductionQuote",
					groupIdFunc: function() {
						return locale.typeId("StyleSourcing", "ProductionQuote");
					}
				},
				{
					m_path: "Child:ProductSourcing/Child:SampleQuote",
					groupIdFunc: function() {
						return locale.typeId("StyleSourcing", "SampleQuote");
					}
				},
				{
					m_path: "Child:ProductSourcing/Child:ProductionQuote/Child:__Parent__/Child:Supplier",
					groupIdFunc: function() {
						return locale.typeId("StyleSourcing", "ProductionQuote") + " - " + locale.type("Supplier");
					}
				},
				{
					m_path: "Child:ProductSourcing/Child:SampleQuote/Child:__Parent__/Child:Supplier",
					groupIdFunc: function() {
						return locale.typeId("StyleSourcing", "SampleQuote") + " - " + locale.type("Supplier");
					}
				}
			],
			StyleSupplierItem: [
				{
					m_path: "Child:LatestRevision",
					groupIdFunc: function() {
						return locale.type("SupplierItem") + " - " + locale.type("_CS_Revision");
					}
				},
				{m_path: "Child:LatestRevision/Child:QuoteFactory"},
				{m_path: "__Parent__|ProductSource"},
				{m_path: "__Parent__|ProductSource/Supplier"},
				{
					m_path: "__Parent__|ProductSource/Supplier|Supplier/Agent",
					groupIdFunc: function() {
						return locale.typeId("Supplier", "Agent");
					}
				},
				{m_path: "__Parent__|ProductSource/__Parent__|StyleSourcing"},
				{m_path: "__Parent__|ProductSource/__Parent__|StyleSourcing/__Parent__|Style"},
				{m_path: "__Parent__|ProductSource/__Parent__|StyleSourcing/__Parent__|Style/Category1"},
				{m_path: "__Parent__|ProductSource/__Parent__|StyleSourcing/__Parent__|Style/Category2"},
				{m_path: "__Parent__|ProductSource/__Parent__|StyleSourcing/__Parent__|Style/Collection"},
				{m_path: "__Parent__|ProductSource/__Parent__|StyleSourcing/__Parent__|Style/ParentSeason"},
				{m_path: "Child:LatestRevision/Child:QuoteProductAlternative"},
				{m_path: "Child:LatestRevision/Child:QuoteProductAlternative/Child:PASpec"}
			]
		},

		/**
		 * Get store filled with attributes for a type, default type is Style.
		 * @return {BrowseAttributesStore} Store of attributes.
		 */
		getAttributesStore: function() {
			return this._createStoreFromType(this.queryFilterType, this.queryFilterPaths[this.queryFilterStartType]);
		},

		/**
		 * Wrap attribute store with grouping store.
		 * @param {BrowseAttributesStore} store - The attributes store.
		 * @return {GroupingStore} The grouping store.
		 */
		_wrapAttributeStore: function(store) {
			var groupingStore = this.inherited(arguments);

			groupingStore.groupIdFunc = function(item) {
				return item.extendedPath.hasOwnProperty("groupIdFunc") && typeof item.extendedPath.groupIdFunc == "function" ? item.extendedPath.groupIdFunc() : locale.type(item.rcOriginal.getType());
			};

			return groupingStore;
		}
	});
});